<template>
  <div>
    <MarketPage />
    <SupportChat :key="'products'" :product="{ id: 'products' }" :show-prompt="true" />
  </div>
</template>

<script setup>
definePageMeta({ layout: 'default' })
</script>
